export const ptDict = {
  'Back to Sign In': 'Voltar para Entrar',
  'Change Password': 'Mudar senha',
  Changing: 'Mudando',
  Code: 'Código',
  'Confirm Password': 'Confirme a Senha',
  'Reset your Password': 'Redefina sua senha',
  'Confirm Sign Up': 'Confirmar inscrição',
  'Confirm SMS Code': 'Confirme o código SMS',
  'Confirm TOTP Code': 'Confirme o código TOTP',
  Confirm: 'confirme',
  'Confirmation Code': 'Código de confirmação',
  Confirming: 'Confirmando',
  'Create Account': 'Criar Conta',
  'Creating Account': 'Criando conta',
  Email: 'O email',
  'Enter your code': 'Insira seu código',
  'Enter your username': 'entre com seu nome de usuário',
  'Enter your phone number': 'Digite seu número de telefone',
  'Enter your email': 'Digite seu e-mail',
  'Forgot your password?': 'Esqueceu sua senha? ',
  'Hide password': 'Esconder a senha',
  Loading: 'Carregando',
  Username: 'Nome do usuário',
  'New password': 'Nova Senha',
  Password: 'Senha',
  'Phone Number': 'Número de telefone',
  'Resend Code': 'Reenviar código',
  'Reset your password': 'Redefina sua senha',
  'Send Code': 'Enviar código',
  'Send code': 'Enviar código',
  Sending: 'Enviando',
  'Setup TOTP': 'Configurar TOTP',
  'Show password': 'Mostrar senha',
  'Sign In': 'Entrar',
  'Sign in': 'Entrar',
  'Sign In with Amazon': 'Entrar com a Amazon',
  'Sign In with Apple': 'Entrar com a Apple',
  'Sign In with Facebook': 'Entrar com o Facebook',
  'Sign In with Google': 'Faça login no Google',
  'Sign in to your account': 'Faça login em sua conta',
  'Create a new account': 'Criar uma nova conta',
  'Signing in': 'Entrando',
  Skip: 'Pular',
  Submit: 'Enviar',
  Submitting: 'Enviando',
  'Verify Contact': 'Verificar contato',
  'Account recovery requires verified contact information':
    'A recuperação da conta requer informações de contato verificadas',
  Verify: 'Verificar',
};
